import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as RadioOnIcon } from '../../assets/images/svg/radio-on.svg';
import themeColors from '../../assets/styles/themeColors';

const RadioOnIconStyled = styled(RadioOnIcon)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  stroke: ${({ color }) => color || themeColors.colorTextSecondary};
`;

const RadioOn = (props) => <RadioOnIconStyled {...props} />;

RadioOn.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

RadioOn.defaultProps = {
  w: '21px',
  h: '21px',
};

export default RadioOn;
